import { AccountantService, ClientService } from "../../services";
import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
} from "@websential/cosmic-v20";
import {
	EMPLOYEE_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {

	formatDate,
	useNavigateToLogout,
	useRemoveQueriesOnUnmount
} from "../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { CollectionVoucherListDataGrid } from "./CollectionVoucherListDataGrid";
import { CollectionVoucherListToolbar } from "./CollectionVoucherListToolbar";
import { IAppState } from "../../store/reducers";
import { IDropDownListResponse } from "../../models/common/IDropDownListResponse";
import { IGetListRequest } from "../../models";
import { PrimeDataGrid } from "../PrimeDataGrid";
import { TransactionsServices } from "../../services/DirectDeposit/TransactionsServices";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { useNavigate } from "react-router-dom";

export interface ICollectionVoucherListPage { }
const COLLECTION_VOUCHER_LIST_QUERY_KEY = "collection-voucher-list-transactions";

const useCollectionVoucherListData = (
	params: IGetListRequest,
) =>
	useQuery({
		queryKey: [
			COLLECTION_VOUCHER_LIST_QUERY_KEY,
			params,
		],
		queryFn: () =>
			TransactionsServices.getCollectionVoucherListData(
				params,

			),
		refetchOnWindowFocus: false,
	});


export const CollectionVoucherList: React.FC<ICollectionVoucherListPage> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedRows, setSelectedRows] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [accountantId, setAccountantId] = useState("all");
	const [collectionVoucherListData, setCollectionVoucherListData] =
		useState<any>(undefined);
	const [runGetListAPICall, setRunGetListAPICall] =
		useState<any>(true);
	const [openDialog, setDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [collectionVoucherId, setCollectionVoucherId] = useState<any>(null);


	const formMethods = useForm<any>({
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const { isPending, data } = useCollectionVoucherListData(
		queryParams,

	);
	const CollectionVoucherList: any | null = data;

	useEffect(() => {
		if (CollectionVoucherList) {
			setCollectionVoucherListData(CollectionVoucherList);
		}
	}, [CollectionVoucherList]);


	//   after click apply button api calls with updated values and update employee report data
	// const collectionVoucherListDataAPICall = (
	// ) => {
	// 	const fetchData = async () => {
	// 		setIsLoading(true);
	// 		try {
	// 			const response: any = await TransactionsServices.getCollectionVoucherListData(
	// 				queryParams,
	// 			);

	// 			if (response) {
	// 				setCollectionVoucherListData(response);
	// 			}
	// 		} catch {
	// 		} finally {
	// 			setIsLoading(false);
	// 		}
	// 	};
	// 	fetchData();
	// };

	const onSubmit = (values: any) => {
		// collectionVoucherListDataAPICall();
	};

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
		setRunGetListAPICall(true)
	}, []);

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const deleteCollectionVoucher = () => {
		if (singleDelete) {
			setSingleDelete(false);
			setDialogOpen(false);
			let delPayload: any = {
				collectionVoucherId: collectionVoucherId,
				navigateToLogout: navigateToLogout,
			};
			deleteCollectionVoucherById(delPayload);
		}
	};
	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setCollectionVoucherId(params.id);
	}, []);

	const { isPending: isDeleting, mutate: deleteCollectionVoucherById } = useMutation({
		mutationFn: TransactionsServices.deleteCollectionVoucherById,
		onSuccess: (res: string | IServerError | IResponse | any) => {
			if (res) {
				// remove the cache of the Accountant fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: res.message ? res.message : "Something went wrong.",
					severity: res.status === false ? "error" : "success",
				});

				queryClient.invalidateQueries({
					queryKey: [COLLECTION_VOUCHER_LIST_QUERY_KEY],
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	}
	);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	useRemoveQueriesOnUnmount(["employee-report"]);

	const updatedCollectionVoucherListItems = useMemo(() => {
		return (
			collectionVoucherListData &&
			collectionVoucherListData.items &&
			collectionVoucherListData?.items.map((item: any) => ({
				...item,
			}))
		);
	}, [collectionVoucherListData]);

	const onRowEditClicked = useCallback((params: any) => {
		let path = `/voucher/collection/setup/${params.id}`;
		navigate(path);
	}, []);


	const expandedLabels = ["Misc.", "Collection Voucher"];
	const expandedCollectionVoucherOrSetupItem = "List";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Collection Voucher" &&
				item.label === expandedCollectionVoucherOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: parentLabel === "Collection Voucher" && item.label === expandedCollectionVoucherOrSetupItem && "/voucher/collection/list",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: EMPLOYEE_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));

		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
	}, [drawerMenuOptions]);



	return (
		<>
			{/* <div
				style={{
					margin: "15px 0",
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
				}}
			>
				{"Collection Voucher List"}
			</div> */}

			{/* <FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
				</form>
			</FormProvider> */}

			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={deleteCollectionVoucher}
					cancelActionHandler={onCloseHandler}
					testId="accountant-field-tab-confirmation-dialog"
				/>
				<BackdropCircularProgress
					open={
						isPending ||
						isLoading
					}
					testId="collection-voucher-list"
				/>


				{/* <CollectionVoucherListDataGrid */}
				<PrimeDataGrid
					columns={
						collectionVoucherListData?.headerColumns
							? collectionVoucherListData.headerColumns.filter(
								(item: any) => item.field !== "id"
							)
							: []
						// collectionVoucherListData?.headerColumns ?? []
					}
					rows={
						collectionVoucherListData && updatedCollectionVoucherListItems
							? updatedCollectionVoucherListItems
							: []
						// collectionVoucherListData?.items ?? []
						// itams
					}
					showIndexColumn={true}
					showChecboxColumn={false}
					showSettingColumn={true}
					onRowEditClicked={onRowEditClicked}
					onRowDeleteClicked={onRowDeleteClicked}
					// onImportButtonClickedHandler={onImportFileClicked}
					// onImportExcelButtonClickedHandler={onExcelToPdfClicked}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						collectionVoucherListData && collectionVoucherListData.total
							? collectionVoucherListData.total
							: 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					searchFieldPlaceholder={"Search..."}
					pageTitle={"Collection Voucher List"}
				// selectedRows={(value: any) => setSelectedRows(value)}
				/>

			</Grid>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
